/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';

import { useKW2P } from '../../../hooks/useKW2P';
import { UserContext } from '../../../context/UserContext';
import { AuthContext } from '../../../context/AuthContext';
import { MascotaCard } from '../../../components/Mascotas/MascotaCard';
import { Loader } from '../../../components/ui/Loader';
import { MascostasData, Mascota } from '../../../interfaces/mascotasInterfaces';
import { ExpedienteAzulFooter } from '../../../components/ui/ExpedienteAzulFooter';
import { BuscadorComponent } from '../../../components/Mascotas/BuscadorComponent';

export const MascotasAdopcion = () => {

    const { languaje } = useContext(UserContext);
    const { handleError, setLoading, isLoading } = useContext(AuthContext);
    const { consultarCatalogoPublic } = useKW2P();

    const [mascotas, setMascotas] = useState<Mascota[]>([]);

    useEffect(() => {
        fetchData([{
            field: 'payload->estado',
            operator: '=',
            value: 'adopcion'
        }]);
    }, []);

    const fetchData = async (where: any[]) => {
        try {
            setLoading(true);
            const { data: { data } } = await consultarMascotasAdopcion(where);
            setMascotas(data);
            setLoading(false);
        } catch (err: any) {
            setLoading(false);
            handleError(err);
        }
    };

    const consultarMascotasAdopcion = (where: any[]): Promise<AxiosResponse<MascostasData>> => {
        const BODY = {
            schema: 'mascotas',
            filter: {
                where
            }
        };

        return consultarCatalogoPublic(BODY);
    }

    return (
        <div className='mascotas__container'>
            <div className="mascotas__header">
                <p>{languaje === 'ES' ? 'Mascotas en Adopción' : 'Pets for Adoption'}</p>
            </div>
            <div className="mascotas__body">
                <BuscadorComponent  scope='adopcion' fetchData={ fetchData }/>
                <div className="row">
                    {
                        mascotas.map((mascota: Mascota) => (
                                <>
                                    { mascota.payload.eliminado === "" || mascota.payload.eliminado === false ? 
                                        <div className="col-12 col-md-6 col-xl-3 card__container" key={ mascota.id }>
                                                <MascotaCard mascota={ mascota } scope='adopcion' />
                                        </div>
                                        : null
                                    }
                                </>
                                ))
                    }
                </div>
            </div>
            <div className="mascotas__footer">
                <ExpedienteAzulFooter/>
            </div>
            { isLoading && <Loader/>}
        </div>
    )
}
